import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AuthGuard } from './guard/auth.guard';
import { PdfViewerContainerComponent } from './pdf-viewer-container/pdf-viewer-container.component';
import { AppComponent } from './app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardSyncComponent } from './modules/datavisualization/dashboard-sync/dashboard-sync.component'; // Importar el componente


let routes: Routes = [];

routes = [
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: AppComponent },
  {
    path: 'pdf-viewer',
    component: PdfViewerContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gasa',
    loadChildren: () => import('./modules/documentos/documentos.module').then((m) => m.DocumentosModule),
  },
  {
    path: 'indama',
    loadChildren: () => import('./modules/ssoma/ssoma.module').then((m) => m.SsomaModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'home',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'admin/dashboard/',
    loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard]
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { 
    path: 'data', 
    loadChildren: () => import('./modules/datavisualization/datavisualization.module').then(m => m.DatavisualizationModule) 
  }
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {
  constructor() {
  }
}